import {
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {CheckboxTreeFilterOption} from "./checkbox-tree-filter-option";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {setUpdateArchiveView, toggleJobFilterValue} from "../../store/actions/filter.actions";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-checkbox-tree-filter',
  templateUrl: './checkbox-tree-filter.component.html',
  styleUrls: ['./checkbox-tree-filter.component.scss'],
})
export class CheckboxTreeFilterComponent implements Overlayable, OnInit, OnDestroy {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Output('stateChanged') onStateChanged = new EventEmitter<CheckboxTreeFilterOption[]>();
  @Input('options') options: CheckboxTreeFilterOption[] = [];
  @Input('filterKey') filterKey = "";

  currentState: number[] = [];

  constructor(private store: Store<AppState>) { }

  ngOnInit() {
    // console.log(this.filterKey);
    this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe((newVal) => {
      this.currentState = newVal;


      const localOptions = JSON.parse(JSON.stringify(this.options));
      // @ts-ignore
      this.options = null;
      this.options = this.setAllState(localOptions);

      this.onStateChanged.emit(this.options);
      // console.log(this.currentState);
    });
  }

  ngOnDestroy() {
    this.store.dispatch(setUpdateArchiveView({updateActive: true}));
  }

  onOptionToggle(option: CheckboxTreeFilterOption) {
    const newState = !(option.selected || option.partiallySelected);
    let toggleIDs: number[] = this.toggleAllChildren(option);
    // console.log(toggleIDs);
    if(newState) {
      toggleIDs = toggleIDs.filter((el) => {
        return !this.currentState.includes(el);
      })
    } else {
      toggleIDs = toggleIDs.filter((el) => {
        return this.currentState.includes(el);
      })
    }
    toggleIDs.forEach((el) => {
      this.store.dispatch(toggleJobFilterValue({key: this.filterKey, value: el}));
    });
  }

  toggleAllChildren(option: CheckboxTreeFilterOption): number[] {
    const toggleIDs: number[] = [];

    if(option.children.length) {
      option.children.forEach((subOption) => {
        if(subOption.children.length) {
          toggleIDs.push(...this.toggleAllChildren(subOption));
        } else {
          toggleIDs.push(subOption.id);
        }
      });
    } else {
      toggleIDs.push(option.id);
    }

    return toggleIDs;
  }

  setAllState(options: CheckboxTreeFilterOption[]): CheckboxTreeFilterOption[] {
    const newOptions: CheckboxTreeFilterOption[] = options.map((el) => {

      if(el.children.length) {
        el.children = this.setAllState(el.children);
        const treeState = this.getTreeState(el);
        el.selected = treeState === 2;
        el.partiallySelected = treeState === 1;
      } else {
        el.selected = this.currentState.includes(el.id);
      }

      return el;
    });

    // console.log(newOptions);
    return newOptions;
  }

  /** 0 - not selected and no children selected */
  /** 1 - has children and any of children selected */
  /** 2 - selected or all children selected */
  getTreeState(option: CheckboxTreeFilterOption): number {
    if(option.children.length) {
      let anyChecked = false;
      let parentState = 2;
      let states: number[] = []
      for(let i = 0; i < option.children.length; i++) {
        states.push(this.getTreeState(option.children[i]));
      }
      if(states.filter(el => el !== 0).length === 0) return 0;
      if(states.filter(el => el !== 2).length === 0) return 2;
      return 1;
    } else {
      if(option.selected) return 2;
      return 0;
    }
  }

  trackItem(index: number, item: CheckboxTreeFilterOption) {
    return item.id;
  }
}
